import { baseRoute } from '../../../constants/routes';

export const CALENDAR_SETTINGS_ROUTE = baseRoute + '/calendar-settings';
export const CALENDAR_REGISTRATION_SETTINGS_ROUTE = baseRoute + '/registration-settings';
export const CALENDAR_APPEARANCES_LIST_ROUTE = baseRoute + '/calendar-appearances';

export const UPDATE_CALENDAR_SETTINGS = 'UPDATE_CALENDAR_SETTINGS';
export const UPDATE_CALENDAR_SETTINGS_SUCCESS = 'UPDATE_CALENDAR_SETTINGS_SUCCESS';

export const UPDATE_CALENDAR_REGISTRATION_SETTINGS = 'UPDATE_CALENDAR_REGISTRATION_SETTINGS';
export const UPDATE_CALENDAR_REGISTRATION_SETTINGS_SUCCESS = 'UPDATE_CALENDAR_REGISTRATION_SETTINGS_SUCCESS';

export const GET_CALENDAR_APPEARANCE_LIST = 'GET_CALENDAR_APPEARANCE_LIST';
export const GET_CALENDAR_APPEARANCE_LIST_SUCCESS = 'GET_CALENDAR_APPEARANCE_LIST_SUCCESS';

export const SHOW_PUBLISH = 'SHOW_PUBLISH';
export const SHOW_PUBLISH_SUCCESS = 'SHOW_PUBLISH_SUCCESS';

export const GET_CALENDAR_SETTINGS = 'GET_CALENDAR_SETTINGS';

export const GET_CALENDAR_SETTINGS_SUCCESS = 'GET_CALENDAR_SETTINGS_SUCCESS' ;